export const SAVE_PERSONAL_STATEMENT_RESET = "SAVE_PERSONAL_STATEMENT_RESET"
export const SAVE_PERSONAL_STATEMENT_REQUEST = "SAVE_PERSONAL_STATEMENT_REQUEST"
export const SAVE_PERSONAL_STATEMENT_SUCCESS = "SAVE_PERSONAL_STATEMENT_SUCCESS"
export const SAVE_PERSONAL_STATEMENT_FAILURE = "SAVE_PERSONAL_STATEMENT_FAILURE"


export const FETCH_PERSONAL_STATEMENT_REQUEST = "FETCH_PERSONAL_STATEMENT_REQUEST"
export const FETCH_PERSONAL_STATEMENT_SUCCESS = "FETCH_PERSONAL_STATEMENT_SUCCESS"
export const FETCH_PERSONAL_STATEMENT_FAILURE = "FETCH_PERSONAL_STATEMENT_FAILURE"